import React from "react";
import { Box, Flex, Button, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import HeaderAuthenticated from "../components/LayoutsComponents/HeaderAuthenticated";
import HeaderComponent from "../components/LayoutsComponents/HeaderComponent";
import SureDeleteAccountView from "../components/User/SureDeleteAccountView";
import i18n from "../i18n/i18n";
import { colors } from "../definitions/constants/GlobalStyles";
import BodyText from "../components/Common/BodyText";

const DeleteAccountPage = () => {
    const { isAuthenticated, loading } = useAuth();
    const navigate = useNavigate();

    const Content = () => {
        if (isAuthenticated) {
            return (
                <Box
                    p={8}
                    maxWidth="600px"
                    mx="auto"
                    mt="40px"
                    bg={colors.surface.white}
                    borderRadius="32px"
                    boxShadow="0px 4px 20px 0px rgba(0, 0, 0, 0.07)"
                >
                    <SureDeleteAccountView />
                </Box>
            );
        }

        return (
            <Flex
                direction="column"
                align="center"
                justify="center"
                p={8}
                maxWidth="800px"
                mx="auto"
                mt="100px"
                gap={6}
                bg={colors.surface.white}
                borderRadius="32px"
                boxShadow="0px 4px 20px 0px rgba(0, 0, 0, 0.07)"
            >
                <Heading as="h1" size="xl" textAlign="center" color={colors.text.black}>
                    {i18n.t("deleteAccount")}
                </Heading>
                <BodyText textAlign="center" fontSize="lg" color={colors.text.lightGray3}>
                    {i18n.t("deleteAccountInstructionsUnauth")}
                </BodyText>
                <Button
                    bg={colors.figmaColors.secColor}
                    color={colors.text.white}
                    _hover={{ bg: "blue.700" }}
                    onClick={() => navigate("/login")}
                    size="lg"
                    borderRadius="12px"
                    height="56px"
                    px={10}
                >
                    {i18n.t("log_in")}
                </Button>
            </Flex>
        );
    };

    if (loading) return null;

    return isAuthenticated ? (
        <HeaderAuthenticated>
            <Content />
        </HeaderAuthenticated>
    ) : (
        <HeaderComponent>
            <Content />
        </HeaderComponent>
    );
};

export default DeleteAccountPage;
